import React, { useEffect } from 'react';
import {
    ShieldCheck,
    Zap,
    Globe,
    Cpu,
    Settings
} from 'lucide-react';
import './About.css';

const About = () => {
    useEffect(() => {
        document.title = "About Us | XHiRE Tech Pvt Ltd";
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="about-page">
            <div className="container about-container">
                <div className="about-content">
                    <div className="sec-tag">ABOUT US</div>
                    <h1 className="about-title">XHiRE Tech Pvt Ltd</h1>
                    <h2 className="about-subtitle">20+ Years Industry Leadership</h2>
                    <p className="about-desc">
                        Driving unparalleled manufacturing excellence through cutting-edge, enterprise-grade software solutions.
                    </p>

                    <div className="about-list">
                        <div className="about-item">
                            <div className="item-icon-box">
                                <ShieldCheck size={24} />
                            </div>
                            <div className="item-text">
                                <strong>Fortifying safety</strong>
                                <p>Specialist in robust enterprise safety systems.</p>
                            </div>
                        </div>

                        <div className="about-item">
                            <div className="item-icon-box">
                                <Zap size={24} />
                            </div>
                            <div className="item-text">
                                <strong>Streamlining production</strong>
                                <p>Expert in TPM & Lean Manufacturing transformation.</p>
                            </div>
                        </div>

                        <div className="about-item">
                            <div className="item-icon-box">
                                <Globe size={24} />
                            </div>
                            <div className="item-text">
                                <strong>Industry validated</strong>
                                <p>The choice of leading manufacturers.</p>
                            </div>
                        </div>

                        <div className="about-item">
                            <div className="item-icon-box">
                                <Cpu size={24} />
                            </div>
                            <div className="item-text">
                                <strong>Sensor Integration</strong>
                                <p>End-to-end IoT sensor connectivity for real-time data capture.</p>
                            </div>
                        </div>

                        <div className="about-item">
                            <div className="item-icon-box">
                                <Settings size={24} />
                            </div>
                            <div className="item-text">
                                <strong>PLC Automation</strong>
                                <p>Seamless integration with PLC systems for intelligent process control.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="about-visual">
                    <div className="visual-image-wrapper">
                        <img
                            src="./assets/modules/featured.jpeg"
                            alt="XHiRE Enterprise Dashboard"
                            className="about-dashboard-img"
                        />
                        <div className="visual-decoration"></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;
